import { ConnectError } from "@connectrpc/connect";

/** Trailer donde el servidor manda el código corto del error (ver
 *  `PasswordResetGrpcService.cs`, `ResetErrorCodeTrailerKey`). */
const RESET_ERROR_CODE_TRAILER = "password-reset-code";

/** Traduce un error de gRPC-Web de `PasswordResetService` al mismo shape JSON
 *  `{ success: false, code, message }` que ya arma el servidor para REST
 *  (`BadRequestCodeException`, ver `LogMiddleware`) y que ya sabe leer
 *  `parsePasswordResetError` — así ni ese parser ni ninguna de las 3 pantallas
 *  (`OlvidePasswordCardRender`, `VerificarCodigoCardRender`,
 *  `RestablecerPasswordCardRender`) necesitan enterarse de que el transporte
 *  cambió. El código viaja en el trailer `password-reset-code`, no en el
 *  mensaje — a diferencia de login, acá no alcanza con el código de status de
 *  gRPC porque los tres pasos distinguen varios motivos de rechazo bajo el
 *  mismo `InvalidArgument`. Piloto real de la migración a gRPC-Web, ver
 *  CLAUDE.md del Server. */
export function mapPasswordResetGrpcError(error: unknown): Error {
  if (!(error instanceof ConnectError)) {
    return new Error("Error de red. Verifica tu conexión a internet.");
  }

  const code = error.metadata.get(RESET_ERROR_CODE_TRAILER);
  if (!code) {
    return new Error(error.rawMessage);
  }

  return new Error(
    JSON.stringify({
      success: false,
      code,
      message: error.rawMessage,
    }),
  );
}
